/**
 * Root route placeholder. Survey links always carry a show hash, specialist
 * and timestamp (see AGENTS.md "Survey URL Structure"); a bare visit to the
 * root has nothing to show.
 */
const Main = () => null;

export default Main;
